var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.suggestion)?_c('div',{staticClass:"pointer mt-2 text-small",on:{"click":_vm.fixTypo}},[_vm._v(" "+_vm._s(_vm.$t('TypoRecognition.message'))+" "),_c('strong',{domProps:{"textContent":_vm._s(_vm.suggestion)}}),_vm._v("? ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }